import lodash from './lodash'
import helper from './helper'

export default app => {
  app.use(lodash)
  app.use(helper)
}
